import type { FaireProductEntity } from "../../entity_types/product";

export const p_yynjerkeq4: FaireProductEntity = {
  token: "p_yynjerkeq4",
  type: "product",
  name: "Laying Strawberry Planter-4\"H-546",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl: "https://cdn.faire.com/fastly/bd1d82815de6b95533dcb395811e29969bd0ef3b17bdf8492c42754e0d01c09b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0dddd7c66f0cd6f32baf888ab464f440d2d7ddfb7e41c13818eea0fec4784d57.jpeg"
  ],
  priceDollars: 14,
  description: "Fans of fruit will be berry, berry happy to discover the distinctive charm of this Laying Strawberry Planter. Crafted out of cement and painted red with lots of rich texture and details, this planter resembles a giant strawberry laid on its side with plenty of room for your favourite colourful flowers, plant or succulents. Vertical Strawberry Planter also available.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:12.024Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
